module.exports = __webpack_public_path__ + "img/platform-logo-transparent-default.c65fe63f.png";